// extracted by mini-css-extract-plugin
module.exports = {"root":"LoginPage_root__yslID"};